import { LocationTracker, usePlayerLocation } from "be-components";
import React, { useEffect, useState } from "react";
import { Modal } from "react-native";
import { View } from "../../../src/Components/Themed";

type LocationHolderProps = {
    visible:boolean,
    mode: 'desktop' | 'mobile',
    player_id?:string,
    onClose: () => void,
    onLocationUpdate:(location:any) => void,
    onModalShow?:(showing:boolean) => void
}

const LocationHolder = ({ visible, player_id, mode, onClose, onLocationUpdate, onModalShow }:LocationHolderProps) => {
    const [showModal, setShowModal] = useState(false);
    const { location, getLocation, permission, checkPermissions, getPermissions } = usePlayerLocation({ player_id: player_id });

    useEffect(() => {
        //checkPermissions({ auto_on_granted: true })
        //getPermissions({ auto_on_granted:true })
    },[]);

    useEffect(() => {
        if(!player_id){ return }
        if(!visible){
            setShowModal(false);
            if(onModalShow) onModalShow(false);
            return;
        }
        // Delay showing modal to allow initial permission check
        const timer = setTimeout(() => {
            setShowModal(true);
            if(onModalShow) onModalShow(true);
        }, 100);
        checkPermissions({ auto_on_granted:true });
        return () => clearTimeout(timer);
    },[visible, player_id]);

    useEffect(() => {
        onLocationUpdate(location);
    },[location])

    return (
        <Modal
            style={{ flex:1 }}
            transparent
            animationType={mode=='desktop' ? 'fade' : 'slide'}
            visible={visible && showModal}
        >
            <View type='blur' style={mode=='desktop' ? { flex:1, justifyContent:'center', alignItems:'center' }:{ flex:1, justifyContent:'flex-end', borderRadius:8, padding:10 }}>
                <View float style={mode=='desktop'? { borderRadius:22, width:500 }:{}}>
                    <LocationTracker
                        permission={permission}
                        location={location}
                        onGetLocation={() => {
                            if(permission.permission != 'granted'){ return getPermissions() }
                            return getLocation()
                        }}
                        onPromptForPermission={() => getPermissions({ auto_on_granted:true })}
                        onClose={() => {
                            return onClose()
                        }}
                    />
                </View>
            </View>
        </Modal>
        
    )
}

export default LocationHolder